module.exports = __webpack_public_path__ + "img/logo-tigo-money.5e576f03.svg";